import React, { useState } from 'react'
import QRCode from "qrcode.react"
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import FormTip from '../../commons/form_tip';

const MIN_SIZE = 100;
const MAX_SIZE = 1000;

declare global {
  interface Window { clipboardData: any; }
}

const index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  const [qrSize, setQrSize] = useState(300);
  const [errorMessage, setErrorMessage] = useState<String>("");

  const changeQrSize = (size) => {
    setErrorMessage("");
    if(size > MAX_SIZE || size < MIN_SIZE){
      setErrorMessage(`QRコードサイズは${MIN_SIZE}〜${MAX_SIZE}の間で指定してください。`);
      return;
    }
    setQrSize(size);
  }

  return(
    <>
      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          { errorMessage }
        </div>
      }
      <div className="form-group col-md-3 no-print">
        <FormTip description={`サイズは${MIN_SIZE}〜${MAX_SIZE}の間で変更できます。`}>
          <label>QRコードサイズ変更</label>
        </FormTip>
        <input 
          className="form-control" 
          placeholder={`${MIN_SIZE}~${MAX_SIZE}で入力してください`}
          type="number" 
          min={MIN_SIZE} 
          max={MAX_SIZE} 
          name="qr_size" 
          id="qr_size"
          defaultValue={qrSize}
          onBlur={(e) => changeQrSize(Number(e.target.value))}
        />
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12 text-center">
        <QRCode value={`https://${location.hostname}/${props.institution.institution_key}/interview/setup`} size={qrSize}/>
      </div>
    </>
  )
}

export default index
